(function () {
  const host = document.querySelector('[data-zk-sn]');
  if (!host) return;

  // Parse items
  let items = [];
  try { items = JSON.parse(host.getAttribute('data-items') || '[]'); }
  catch (e) { items = []; }

  if (!Array.isArray(items) || items.length === 0) return;

  // Parse config
  let cfg = {};
  try { cfg = JSON.parse(host.getAttribute('data-config') || '{}'); }
  catch (e) { cfg = {}; }

  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  // Position (Desktop vs Mobile)
  const posDesktop = cfg.position || 'bottom_left';
  const posMobile = (cfg.position_mobile && String(cfg.position_mobile).trim())
    ? cfg.position_mobile
    : posDesktop;

  host.setAttribute('data-pos', isMobile ? posMobile : posDesktop);

  // Max width
  const maxw = Number(cfg.max_width || 280);
  if (Number.isFinite(maxw) && maxw > 0) {
    host.style.setProperty('--zk-sn-maxw', maxw + 'px');
  }

  // Device visibility
  const dv = (cfg.device_visibility || 'both');
  if (dv === 'mobile' && !isMobile) return;
  if (dv === 'desktop' && isMobile) return;

  const locale = String(cfg.locale || 'en').toLowerCase();
  const isArabic = locale.startsWith('ar');

  // Colors
  const textColor = cfg.text_color || '#FFFFFF';
  const accent = cfg.accent_color || '#E4A92C';
  const bgColor = '#4F2011';
  host.style.setProperty('--zk-sn-bg', bgColor);
  const borderThickness = Number(cfg.border_thickness ?? 1);

  // Glass
  const useGlass = false;  

  const sentence = (mins) => {
    const m = Math.max(1, Number(mins || 1));
    return isArabic ? `تم الشراء منذ ${m} دقيقة` : `Purchased ${m} min ago`;
  };

  const parseSchedule = (str) => {
    const raw = String(str || '').trim();
    if (!raw) return [1000, 6000, 20000, 60000, 180000];

    const arr = raw
      .split(',')
      .map(s => Number(s.trim()))
      .filter(n => Number.isFinite(n) && n > 0)
      .map(sec => sec * 1000);

    return arr.length ? arr : [1000, 6000, 20000, 60000, 180000];
  };

  const schedule = parseSchedule(cfg.schedule_seconds);
  const loopAfter = !!cfg.loop_after_schedule;
  const loopInterval = Number(cfg.loop_interval_ms || 300000);

  let index = -1;
  const nextItem = () => {
    if (cfg.randomize) return items[Math.floor(Math.random() * items.length)];
    index = (index + 1) % items.length;
    return items[index];
  };

  const safeText = (v) => String(v || '').replace(/[<>&"]/g, (ch) => ({
    '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;'
  }[ch]));

  const renderCard = (item) => {
    const name = isArabic ? (item.name_ar || item.name_en || '') : (item.name_en || item.name_ar || '');
    const productTitle = isArabic ? (item.product_title_ar || item.product_title_en || '') : (item.product_title_en || item.product_title_ar || '');
    const loc = isArabic ? (item.location_ar || item.location_en || '') : (item.location_en || item.location_ar || '');
    const mins = item.time_minutes;

    const img = String(item.image || '').trim();
    const url = String(
    (isArabic ? (item.product_url_ar || item.product_url_en) : (item.product_url_en || item.product_url_ar))
    || item.product_url
    || ''
  ).trim();

    const bg = useGlass
      ? `rgba(255,255,255,${Math.min(1, Math.max(0, glassOpacity))})`
      : bgColor;

    const dirAttr = isArabic ? 'rtl' : 'ltr';

    const imageHTML = img
      ? `<img class="zk-sn__img" src="${safeText(img)}" alt="" loading="lazy" />`
      : `<span class="zk-sn__img--ph" aria-hidden="true"></span>`;

    return `
      <div class="zk-sn__card"
           role="status" aria-live="polite" dir="${dirAttr}"
           data-url="${safeText(url)}"
           style="
             color:${textColor};
             background:${bg};
             border:${borderThickness}px solid rgba(0,0,0,.06);
           ">
        <div class="zk-sn__media">${imageHTML}</div>

        <div class="zk-sn__content">
          <div class="zk-sn__name">${safeText(name)}</div>

          <div class="zk-sn__line">
            <span class="zk-sn__badge">
              <span class="zk-sn__dot" style="background:${accent}"></span>
              ${safeText(sentence(mins))}
            </span>
          </div>

          <p class="zk-sn__product">
            ${url
              ? `<a class="zk-sn__link" href="${safeText(url)}">${safeText(productTitle)}</a>`
              : safeText(productTitle)
            }
          </p>

          <div class="zk-sn__meta">
            ${loc ? `<span>${safeText(loc)}</span>` : ``}
          </div>
        </div>

        <button class="zk-sn__close" type="button" aria-label="Close">×</button>
      </div>
    `;
  };

  let hideTimer = null;
  let loopTimer = null;

  const showOnce = () => {
    const item = nextItem();
    host.innerHTML = renderCard(item);

    const card = host.querySelector('.zk-sn__card');
    const close = host.querySelector('.zk-sn__close');

    const hide = () => {
      if (!card) return;
      card.classList.remove('is-visible');
      clearTimeout(hideTimer);
      setTimeout(() => { host.innerHTML = ''; }, 250);
    };

    // Close
    if (close) close.addEventListener('click', (e) => { e.stopPropagation(); hide(); });

    // Card click => open product (except close / links handle themselves)
    if (card) {
      card.addEventListener('click', (e) => {
        const isClose = e.target && e.target.closest && e.target.closest('.zk-sn__close');
        if (isClose) return;

        const a = e.target && e.target.closest && e.target.closest('a');
        if (a) return; // default link

        const url = card.getAttribute('data-url');
        if (url) window.location.href = url;
      });

      // Keyboard access
      card.tabIndex = 0;
      card.setAttribute('role', card.getAttribute('data-url') ? 'link' : 'status');
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          const url = card.getAttribute('data-url');
          if (url) window.location.href = url;
        }
      });
    }

    requestAnimationFrame(() => card && card.classList.add('is-visible'));

    const visibleMs = Number(cfg.display_ms || 4500);
    hideTimer = setTimeout(hide, visibleMs);
  };

  // Schedule
  schedule.forEach((delay) => setTimeout(showOnce, delay));

  // Loop
  if (loopAfter) {
    const last = schedule[schedule.length - 1] || 0;
    setTimeout(() => {
      clearInterval(loopTimer);
      loopTimer = setInterval(showOnce, loopInterval);
    }, last);
  }
})();
